import React, { Component } from 'react';
import Button from 'material-ui/Button';
import Dialog, {
  DialogTitle,
  DialogContent,
  DialogActions
} from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import validate from 'validate.js';
import isEmpty from 'lodash/isEmpty';
import {withStyles} from 'material-ui/styles/index';
const constraints = {
  password: {
    presence: true,
  },
  passwordConfirm: {
    presence: true,
    equality: {
      attribute: 'password',
      message: `Salasanat eivät täsmää`,
    },
  },
};

const styles = theme => ({
	input: {
		width: '100%',
	}
});

class ChangePasswordDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        password: '',
        passwordConfirm: '',
      },
      errors: {},
      touchedFields: [],
      isValid: false,
    };
  }

  handleCancel = () => {
    this.props.onRequestClose();
  };
  handleChange = () => {
    this.props.onRequestChange(this.state.data);
  };

  validate = () => {
    const { data } = this.state;
    const errors =
      validate(data, constraints, {
        format: 'custom',
      }) || {};
    const isValid = isEmpty(errors);
    this.setState({
      errors,
      isValid,
    });
  };
  onInputChange = event => {
    const { name } = event.target;
    if (name === '') return;
    this.updateData(event);
  };
  onBlur = event => {
    this.updateTouchedfields(event);
    this.validate();
  };

  updateTouchedfields(event) {
    const { name } = event.target;
    if (name === '') return;
    const touchedFields = [
      ...this.state.touchedFields.filter(item => item !== name),
      name,
    ];
    this.setState({
      touchedFields,
    });
  }

  updateData(event) {
    const target = event.target;
    const { value, name } = target;
    if (name === '') return;
    var newData = {
      ...this.state.data,
      [name]: value,
    };

    this.setState(
      {
        data: { ...newData },
      },
      () => {
        this.validate();
      }
    );
  }
  
  render() {
    const { onRequestChange, classes, ...other } = this.props;
    const { isValid, errors, touchedFields } = this.state;
    return (
      <Dialog onRequestClose={this.handleRequestClose} {...other}>
        <DialogTitle>Vaihda salasana</DialogTitle>
        <DialogContent>
          <TextField
            name="password"
            label="Salasana"
            type="password"
            autoComplete="off"
            margin="normal"
            className={classes.input}
            onBlur={this.onBlur}
            onChange={this.onInputChange}
            value={this.state.password}
          />
          <TextField
            name="passwordConfirm"
            label="Vahvista uusi salasana"
            type="password"
            autoComplete="off"
            margin="normal"
            className={classes.input}
            onBlur={this.onBlur}
            error={
              errors['passwordConfirm'] &&
              touchedFields.indexOf('passwordConfirm') > -1
            }
            onChange={this.onInputChange}
            value={this.state.passwordConfirm}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel} color="primary">
            Peruuta
          </Button>
          <Button
            disabled={!isValid}
            onClick={this.handleChange}
            color="primary"
          >
            Vaihda salasana
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default withStyles(styles)(ChangePasswordDialog);



// WEBPACK FOOTER //
// ./src/modules/user/components/ChangePasswordDialog.js